var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('lead-custom-fields'),_vm._v(" "),(_vm.authUserIsOwner)?_c('lead-bulk-delete'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }